<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-07 11:14:49
 * @最后编辑: Betway
 * @最后修改时间: 2022-01-06 13:25:05
-->
<template>
  <div class="labelTrans">
    <!-- :showEdit='disabled' -->
    <mrc_ess_iconGroup @handleReturn="handleReturn" @handleEdit="handleEdit" :showReturn="false"
      :showEdit="hasBtn('edit-label-translate-internationalization')" :show_del="false">
      <!--   v-btnAuth="['batch-upload']" -->
      <mrc_ess_uploadBtn @sendRequest="sendRequest" :fn="fn" v-btnAuth="['upload-label-internationalization-data']"
        :label="$t('label_Batch_Import')" @findError="findError" :uploadLoading="uploadLoading" :resStatus="resStatus">
      </mrc_ess_uploadBtn>
      <!-- <v-btn small
             @click="downTemp"
             rounded
             v-btnAuth="['download-label-internationlization-template']"
             class="white--text px-5 py-5 mr-2"
             color="primary">
        {{ $t('label_Download_the_template') }}
      </v-btn> -->
      <v-btn small rounded class="white--text px-5 py-5 mr-2" v-btnAuth="['download-label-internationalization-data']"
        color="primary">
        {{ $t("label_Download_the_CVS") }}
      </v-btn>
      <!-- <v-btn small
             rounded
             class="white--text px-5 py-5 mr-2"
             v-btnAuth="['upload-label-internationalization-data']"
             color="primary">
        {{$t('label_Upload_CVS')}}
      </v-btn> -->
    </mrc_ess_iconGroup>
    <mrc_ess_table :headers="headers" hideAddBtn :paginationOptions="paginationOptions" @turnPage="turnPage"
      :laoding="loading" :slotKey="['language_master_final_key']" :items="items">
      <!-- 表格上部分搜索框 -->
      <template v-slot:top>
        <v-row>
          <v-col class="d-flex" cols="12" sm="4">
            <mrc_ess_searchInput class="ml-4" :placeholder="$t('Search_key') + '/' + $t('label_The_path') + '/value'
              " append-icon="mdi-magnify" />
          </v-col>
        </v-row>
      </template>

      <template v-slot:item.language_master_final_key="{ item }">
        <span>{{ item.language_master_final_key }}</span>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="openDialog(item)">
          mdi-pencil
        </v-icon>
        <v-icon small v-btnAuth="['delete-label-translate-internationalization']" @click="deleteItem(item)">
          mdi-delete
        </v-icon>
      </template>
    </mrc_ess_table>
    <!-- 提交 -->
    <mrc_ess_submitBtn @cancel="tableCancel" v-show="!disabled" :loading="submitLoading" @success="tableSuccess">
    </mrc_ess_submitBtn>
    <!-- 修改新增的弹窗 -->
    <mrc_ess_myDialog v-model="dialogFlag" @cancel="dialogCancel" @success="dialogSuccess"
      :title="dialogData.language_master_content" width="600">
      <v-card-subtitle class="text-right">{{
        dialogData.uuid
      }}</v-card-subtitle>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="12">
            <mrc_ess_input placeholder="名称" label="名称*" v-model="dialogData.language_master_final_key"></mrc_ess_input>
          </v-col>
          <v-col cols="12" sm="12">
            <mrc_ess_input placeholder="路径" v-model="dialogData.language_version_uuid" label="路径*"></mrc_ess_input>
          </v-col>
        </v-row>
        <h3 class="mt-6 mb-4">翻译</h3>
        <div style="border: 1px solid #dedede; border-radius: 10px" class="rounded-lg px-6 py-4">
          <v-row>
            <v-col cols="12" v-for="(item, index) in language" :key="index" sm="12">
              <!-- 去掉了.trim 2021-01-06 hb -->
              <mrc_ess_input :placeholder="item.text" v-model="dialogData[item.value]" :label="item.text"></mrc_ess_input>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
    </mrc_ess_myDialog>
    <!-- isNational -->
    <!-- <mrc_ess_multiText label='名称'
                       isNational
                       @change="cahnge"
                       v-model="fields1"></mrc_ess_multiText> -->
  </div>
</template>

<script>
import Cookie from "js-cookie";
import {
  uploadFileAll,
  uploadFileUser,
  uploadFileOrg,
} from "@/service/api/upload.js";
import {
  downTemplate,
  uploadHint,
  labelVersionList,
  saveLabelTranslate,
  delNationalData,
} from "@/service/api/internationalization";
export default {
  components: {},
  props: {},
  data() {
    return {
      fn: null,
      uploadLoading: null,
      tableStatus: false,
      resStatus: null,
      submitLoading: false,
      dialogData: {
        language_master_content: "",
        language_version_uuid: "",
      },
      loading: false,
      dialogFlag: false,
      paginationOptions: {
        pagesize: this.$store.state.pageSize,
        cpage: 1,
        totalcount: 0, //总条数
        totalpage: 0, //总页数
      },
      fields1: [
        { en: "", uuid: "" },
        { zh: "", uuid: "" },
        { as: "", uuid: "" },
      ],
      fields: "asd",
      headers: [],
      items: [],
      versionValue: "",
      labelValue: "",
      client_typeValue: "",
      language: [],
      disabled: true,
    };
  },
  created() { },
  async mounted() {
    const value = this.$route.params.uuid || this.$store.state.uuid;
    const name =
      this.$store.state.client_type +
      (this.$store.state.version ? "---" + this.$store.state.version : "");
    if (name) {
      this.client_typeValue = this.$store.state.client_type;
      this.versionValue = this.$store.state.version;
    }

    await this.turnPage(this.paginationOptions);
  },
  methods: {
    findError() {
      this.fn = getStaffLeaveList;
    },
    async sendRequest(val) {
      //发送请求上传文件
      // console.log(val);
      this.uploadLoading = true;
      let formData = new FormData();
      formData.append("attachment_file", val);
      formData.append(
        "formData",
        JSON.stringify({
          module_uuid: this.$store.state.menuFunctionUuid,
          "~table~": "mrbase_sys_language_version",
          token: this.$ls.get("token"),
        })
      );
      const res = await uploadFileAll(formData);
      if (res.code == 200) {
        this.uploadLoading = false;
        this.resStatus = true;
      } else {
        this.uploadLoading = false;
        this.resStatus = false;
      }
    },
    uploadCVS() { },
    downTemp() {
      downTemplate({ module_name: "版本信息模板.xlsx" });
    },
    getlist() { },
    dialogCancel() { },
    handleReturn() {
      this.$router.go(-1);
    },
    handleEdit() {
      this.disabled = !this.disabled;
      this.$set(this.headers, this.headers.length, {
        text: "",
        align: "start",
        sortable: false,
        value: "actions",
        width: 100,
      });
    },
    tableCancel() {
      this.$myConfirm({
        content: this.$t("message_Confirm_the_cancellation_of_the_edit"),
      })
        .then(async () => {
          this.$set(this.headers, this.headers.length - 1, {
            text: "",
            align: "start",
            sortable: false,
            value: "",
            width: 0,
          });
          this.disabled = !this.disabled;
          await this.turnPage(this.paginationOptions);
        })
        .catch(() => { });
    },
    async tableSuccess() {
      this.submitLoading = true;
      this.items.forEach((item) => {
        delete item.created_by;
        delete item.created_utc_datetime;
        delete item.updated_by;
        delete item.updated_utc_datetime;
      });
      const res = await saveLabelTranslate({
        mrbase_sys_language_values: this.items,
      });
      if (res.code == 200) {
        this.$store.commit(
          "newsTips",
          this.$t("message_The_submission_was_successful")
        );
        this.disabled = !this.disabled;
        this.headers.pop();
        this.$set(this.headers, this.headers.length, {
          text: "",
          align: "start",
          sortable: false,
          value: "",
          width: 0,
        });
      }
      this.submitLoading = false;
    },
    cahnge(val) {
      console.log(val);
    },
    openDialog(item) {
      this.dialogData = this.$clone(item);
      this.dialogFlag = true;
    },
    deleteItem(item) {
      const index = this.items.indexOf(item);
      this.$myConfirm({ content: this.$t("message_Confirm_the_deletion") })
        .then(async () => {
          const res = await delNationalData({ uuid: item.uuid });
          if (res.code == 200) {
            this.items.splice(index, 1);
            this.$Message({
              text: this.$t("message_The_deletion_was_successful"),
            });
            // await this.turnPage(this.paginationOptions)
            // this.$set(this.headers, this.headers.length - 1,
            //   {
            //     text:'',
            //     align: 'start',
            //     sortable: false,
            //     value: 'actions',
            //     width: 100
            //   })
          }
        })
        .catch(() => { });
    },
    dialogSuccess() {
      const index = this.items.findIndex((item) => {
        return item.uuid == this.dialogData.uuid;
      });
      this.$set(this.items, index, this.dialogData);
      this.dialogFlag = false;
    },
    /**
     * @description: 请求table数据
     * @param {type}
     * @return:
     * @author: lwq
     */
    async turnPage({ pagesize, cpage }) {
      this.loading = true;
      const res = await labelVersionList({
        client_type: this.client_typeValue,
        version: this.versionValue,
        pindex: cpage,
        psize: pagesize,
      });
      // {zh: '中文'}
      if (res.code == 200) {
        this.paginationOptions.totalcount = res.data.total;
        this.paginationOptions.totalpage = res.data.totalPage;
        this.paginationOptions.pagesize = pagesize;
        const title = res.mrbase_sys_language_code.map((item, index) => {
          return {
            text: item.language_name,
            align: "start",
            sortable: false,
            value: item.language_code,
            width: 100,
          };
        });
        this.language = title;
        this.headers = [
          {
            text: "id,名称及路径",
            align: "start",
            sortable: false,
            value: "language_master_final_key",
            width: "200px",
          },
          ...title,
          // {
          //   text: '',
          //   align: 'start',
          //   sortable: false,
          //   value: '',
          //   width: 0
          // }
        ];
        const list = res.mrbase_sys_language_master;
        this.items = list;
      }

      this.loading = false;
      if (this.disabled) {
        this.$set(this.headers, this.headers.length, {
          text: "",
          align: "start",
          sortable: false,
          value: "",
          width: 0,
        });
      } else {
        this.$set(this.headers, this.headers.length, {
          text: "",
          align: "start",
          sortable: false,
          value: "actions",
          width: 100,
        });
      }
    },
  },
  computed: {},
  watch: {},
};
</script>

<style scoped>
.labelTrans /deep/ table>tbody>tr>td:first-child,
.labelTrans /deep/ table>thead>tr>th:first-child,
.labelTrans /deep/ table>tbody>tr>td:last-child,
.labelTrans /deep/ table>thead>tr>th:last-child {
  position: sticky !important;
  position: -webkit-sticky !important;
  z-index: 2 !important;
  background: white !important;
}

.labelTrans /deep/ table>thead>tr>th:first-child,
.labelTrans /deep/ table>thead>tr>th:last-child {
  z-index: 3 !important;
}

.labelTrans /deep/ table>tbody>tr>td:first-child,
.labelTrans /deep/ table>thead>tr>th:first-child {
  left: 0 !important;
  width: 200px;
  word-break: break-all;
  white-space: pre-wrap;
}

.labelTrans /deep/ table>tbody>tr>td:last-child,
.labelTrans /deep/ table>thead>tr>th:last-child {
  right: 0 !important;
}
</style>
